import { ToastConfig } from '@shared/ui';

/**
 * Bridge that lets non-React modules (the QueryClient's cache `onError` handlers, built
 * at module scope in App.tsx — outside the React tree) raise a toast through the live
 * `ToastProvider`. The provider registers its `showToast` on mount; `emitToast` is a no-op
 * until then (no queries run before the provider mounts, so nothing is lost).
 */
type ShowToast = (config: ToastConfig) => void;

let current: ShowToast | null = null;

export const registerToast = (fn: ShowToast | null): void => {
  current = fn;
};

export const emitToast = (config: ToastConfig): void => {
  current?.(config);
};
